module.exports = __webpack_public_path__ + "img/hero-mobile.68c4deb.webp";